import { ButtonStyle } from "./styles/ButtonStyle";

export const Button = ({ onClick }) => {
 return <ButtonStyle onClick={onClick}>Restart</ButtonStyle>;
};
